export enum AppointmentAnalyticsModuleName {
  digitalInvite = 'digital-invite',
}
